export const canDisplayError = (variant: string) => ['fresh'].includes(variant);

export const errorEnterTransition = { delay: 0.3, duration: 0.5 };
export const errorExitTransition = { delay: 0, duration: 0.3 };
